import {mapMutations} from "vuex";

export default {
    /**
     * данные компонента
     * @property {object} filterData - данные фильтра
     * @property {object} filterDataSelected - выбранные данные фильтра
     */
    data: () => ({
        filterData: {},
        filterDataSelected: {},
    }),
    methods: {
        /**
         * проксируем мутации из стора
         * @property {Function} setCurrentViewName - установить текущее имя страницы
         */
        ...mapMutations([
            'setFilterSelected'
        ]),
        /**
         * установить данные фильтра
         * @param {object} filter 
         */
        setFilterData(filter) {
            let {main = {}, selected = {}} = filter;
            this.filterData = main;
            this.filterDataSelected = selected;
            this.setFilterSelected(selected);
        },
    }
}